import AxiosInstance from "@/core/services/axios.service";

// Action Types
export const FETCH_CALL_RESULT_CODES = "fetchCallResultCodes";

// Mutations Types
const SET_CALL_RESULT_CODES = "setCallResultCodes";

const state = {
  callResultCodes: [],
  callResultCode: {},
};

const getters = {
  callResultCodes(state) {
    return state.callResultCodes;
  },
};

const actions = {
  [FETCH_CALL_RESULT_CODES]({ commit }) {
    return new Promise((resolve, reject) => {
      AxiosInstance.get("call-results")
        .then(({ data }) => {
          commit(SET_CALL_RESULT_CODES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  },
};

const mutations = {
  [SET_CALL_RESULT_CODES](state, callResultCodes) {
    state.callResultCodes = callResultCodes;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
